import { Component, Input, ViewChild } from '@angular/core';

import { take } from 'rxjs/operators';
import { ApiError, ButtonLoader, MessageService } from '../../../../core';
import { PessoaContatoTipo } from '../../../pessoa/contato';
import { LeadContatoFormComponent } from './form';
import { LeadContato } from './lead-contato';
import { LeadContatoHttpService } from './services';
import { LeadContatoTableComponent } from './table';

@Component({
    selector: 'sgt-lead-contato',
    templateUrl: './lead-contato.component.html',
    styleUrls: ['./lead-contato.component.less']
})
export class LeadContatoComponent {
    @Input() idLead: number;
    @Input() entities: LeadContato[];
    @Input() persistSaves = false;

    // Table
    @Input() showTableTitle = true;
    @Input() tableMaxHeight = 'none';
    @ViewChild('table') table: LeadContatoTableComponent;

    // Form
    isFormOpen: boolean;
    isFormEdit: boolean;
    entityIndexEditing: number;
    @ViewChild('form') form: LeadContatoFormComponent;
    tiposContatos: PessoaContatoTipo[];
    /** Se o form deve ser exibido em tamanho pequeno */
    @Input() isMini = false;

    constructor(private messageService: MessageService,
                private leadContatoHttpService: LeadContatoHttpService) { }

    insert(tipoContato: PessoaContatoTipo) {
        this.isFormOpen = true;
        this.isFormEdit = false;
        this.entityIndexEditing = null;
        setTimeout(() => this.form.insert(tipoContato.id), 0);
    }

    edit(index: number) {
        if (index == null || index === undefined || index < 0) {
            return;
        }

        this.isFormOpen = true;
        this.isFormEdit = true;
        this.entityIndexEditing = index;
        setTimeout(() => this.form.edit(this.entities[index]), 0);
    }

    delete(index: number) {
        if (index == null || index === undefined || index < 0) {
            return;
        }

        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir o contato ${entity.nome}?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
                this.table.refresh();
            }
        });
    }

    /** Persiste e insere o novo contato no banco de dados */
    private persistInsert(entity: LeadContato): Promise<LeadContato> {
        return new Promise<LeadContato>((resolve, reject) => {
            this.leadContatoHttpService.insert(this.idLead, entity)
                .pipe(
                    take(1)
                )
                .subscribe(
                    response => resolve(response),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Persiste e insere o novo contato no banco de dados */
    private persistUpdate(entity: LeadContato): Promise<LeadContato> {
        return new Promise<LeadContato>((resolve, reject) => {
            this.leadContatoHttpService.update(entity)
                .pipe(
                    take(1)
                )
                .subscribe(
                    response => resolve(response),
                    (error: ApiError) => reject(error)
                );
        });
    }

    async save() {
        if (!this.form.isValid()) {
            this.messageService.info('Para salvar o contato é preciso informar corretamente todos os campos destacados em vermelho', 'Informação');
            return;
        }

        try {
            const btnSave = new ButtonLoader('#btnSaveContato');
            btnSave.loading('Salvando');

            let entity = this.form.entity;

            if (this.isFormEdit) { // Edit
                // Se for para persistir e atualizar no banco de dados
                if (this.persistSaves) {
                    entity = await this.persistUpdate(entity);
                }

                this.entities[this.entityIndexEditing] = entity;
            } else { // Insert
                // Se for para persistir e inserir no banco de dados
                if (this.persistSaves) {
                    entity = await this.persistInsert(entity);
                }

                this.entities.push(entity);
            }

            btnSave.reset();
            this.afterSave();
        } catch (error) {
            this.messageService.error('Ocorreu um erro ao salvar o contato. Tente novamente', 'Erro', error);
        }
    }

    /** Seta o foco no form do contato */
    setFocusForm() {
        this.form?.setFocus();
    }

    private closeForm() {
        this.isFormOpen = false;
        this.isFormEdit = false;
        this.entityIndexEditing = null;
    }

    private afterSave() {
        this.closeForm();
    }

    cancel() {
        this.closeForm();
    }
}
